import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const LazyStudentHomeIndex = React.lazy(
	() => import(/* webpackChunkName: 'StudentHomeIndex' */ './components')
);

export default () => {
	return {
		index: true,
		element: <AsyncLoading component={<LazyStudentHomeIndex />} />,
	};
};
